import { AppointmentSlotsByDate, Provider } from "~/services";
import { formatDateKey } from "~/utils";

type DayAvailabilityParams = {
  date: Date;
  isProviderView?: boolean;
  appointmentSlotsByProvider?: Provider[];
  appointmentSlotsByFirstAvailable?: AppointmentSlotsByDate;
  providerId?: number;
};

export const isSelectableDay = ({
  date,
  isProviderView = true,
  appointmentSlotsByProvider,
  appointmentSlotsByFirstAvailable,
  providerId,
}: DayAvailabilityParams): boolean => {
  const dateString = formatDateKey(date);

  if (!isProviderView) {
    return (appointmentSlotsByFirstAvailable?.[dateString]?.length ?? 0) > 0;
  }

  if (providerId) {
    const provider = appointmentSlotsByProvider?.find(
      (p) => p.id === providerId,
    );
    return Boolean(provider?.slots[dateString]);
  }

  return (
    appointmentSlotsByProvider?.some(
      (provider) => provider.slots[dateString],
    ) ?? false
  );
};
